import { injectable, interfaces } from 'inversify';
import { action, IObservableArray, makeObservable, observable } from 'mobx';
import { Alert } from './models/Alert';

export interface IAlertBarStore {
  alerts: Alert[];
  setAlerts(alerts: Alert[]): void;
}

export namespace IAlertBarStore {
  export const $: interfaces.ServiceIdentifier<IAlertBarStore> = Symbol('ALERT_BAR_STORE');
}

@injectable()
export class AlertBarStore implements IAlertBarStore {
  alerts: IObservableArray<Alert> = observable.array([]);

  constructor() {
    makeObservable(this, {
      alerts: observable,
      setAlerts: action,
    });
  }

  setAlerts(alerts: Alert[]): void {
    this.alerts.replace(alerts);
  }
}
